<script lang="ts">
    import {createEventDispatcher} from 'svelte';
    import {inputFocusedStore} from '../../stores/inputFocus';

    export let value;
    export let title;
    export let validator = null;
    export let required = false;
    export let active = true;
    let focused = false;
    let inputEl;
    let inputValid = true;


    const dispatch = createEventDispatcher();

    function updateValue() {
        if (validator) {
            inputValid = validateValue();
        } else {
            inputValid = true;
        }
        if (inputValid) {
            dispatch('configValueChanged', value);
        }
    }

    function validateValue(): boolean {
        if (!value && !required) return true;
        return validator(value);
    }

    function onKeyDown(event) {
        if (event.key === 'Enter') {
            updateValue();
            inputEl.blur();
        }
    }

    function onFocus() {
        focused = true;
        inputFocusedStore.set(true);
    }

    function onBlur() {
        focused = false;
        inputFocusedStore.set(false);
    }

    function onKeyPress() {
    }
</script>

<div style="width: 100%" class="flex flex-row bg-center text-input-combination pt-1 w-fit">
    <label class="basis-1/4 text-input-label">{title}: </label>
    {#if active}
        <input bind:this="{inputEl}" type="text"
               class="input input-ghost input-xs {!inputValid ? 'input-error' : ''  } w-full max-w-xs basis-3/4"
               bind:value={value} on:keypress="{onKeyDown}" on:focus={onFocus} on:blur={onBlur}
               on:focusout="{updateValue}" on:keypress|stopPropagation={onKeyPress}/>
    {:else }
        <input bind:this="{inputEl}" type="text"
               class="input input-ghost input-xs {!inputValid ? 'input-error' : ''  } w-full max-w-xs basis-3/4"
               bind:value={value} disabled/>
    {/if}
</div>
